import permissions from "app/permissions";
import { RECORDS, STUDENT_EDUCATION, StudentServicePath } from "utils/constants";
import StudentRecord from "./StudentRecord";

export const resources = {
  name: StudentServicePath + RECORDS + "/" + STUDENT_EDUCATION + "/:id/",
  title: "Студентски картон",
  custom: <StudentRecord />,
  permission: permissions.canPreviewStudentRecords,
  isMenu: false,
};
